import { css } from '@compiled/react';
import React from 'react';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';
import { useDeviceSize } from '@atlassian/learning-components';
import WarningIcon from '@atlaskit/icon/core/warning';

export const Banner: React.FC<{ isBreadcrumbVisible: boolean; isStandalone: boolean }> = ({
  isBreadcrumbVisible,
  isStandalone,
}) => {
  const deviceWidth = useDeviceSize();
  const MAIN_NAV_HEIGHT = 68;
  const SUB_NAV_HEIGHT = 68;
  const BREADCRUMBS_NAV_HEIGHT_DESK = 68;
  const BREADCRUMBS_NAV_HEIGHT_MOBILE = 56;
  const SIDEBAR_HEIGHT_MOBILE = 48;

  return (
    <div
      css={[
        bannerContainerStyles,
        isStandalone && css({ paddingLeft: '14px !important', justifyContent: 'center !important' }),
        css({
          top: isBreadcrumbVisible
            ? `${MAIN_NAV_HEIGHT + SUB_NAV_HEIGHT + BREADCRUMBS_NAV_HEIGHT_DESK}px`
            : `${MAIN_NAV_HEIGHT + SUB_NAV_HEIGHT}px`,
        }),
        deviceWidth < 1280 && css({ top: isBreadcrumbVisible ? `${SUB_NAV_HEIGHT}px` : 0 }),
        deviceWidth < 768 && css({ top: isBreadcrumbVisible ? `${BREADCRUMBS_NAV_HEIGHT_MOBILE}px` : 0 }),
        deviceWidth < 480 &&
          css({
            top: isBreadcrumbVisible
              ? `${BREADCRUMBS_NAV_HEIGHT_MOBILE + SIDEBAR_HEIGHT_MOBILE}px`
              : `${SIDEBAR_HEIGHT_MOBILE}px`,
          }),
        deviceWidth <= 480 && isStandalone && css({ top: 0 }),
      ]}
      data-testid="warning-banner"
    >
      <WarningIcon label="banner warning icon" />
      <p css={bannerWarningStyles}>
        We’re having some issues with missing or incorrect images and videos. We’re working on a fix - it should be
        resolved soon. Thanks for your patience.
      </p>
    </div>
  );
};

const bannerContainerStyles = css({
  position: 'relative',
  width: '100%',
  backgroundColor: token('color.background.warning.bold'),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `14px ${token('space.150')} 14px 60px`,

  [media.below.md]: {
    justifyContent: 'flex-start !important',
  },

  [media.below.xs]: {
    padding: token('space.150'),
  },
});

const bannerWarningStyles = css({
  marginLeft: token('space.100'),
  marginTop: 0,
  fontFamily: 'Inter, sans-serif',
  fontSize: '14px',
  lineHeight: '20px',

  [media.below.xs]: {
    fontSize: '12px',
    fontHeight: '18px',
  },
});
